import styled, {css} from 'styled-components';

import {ZIndex} from 'styles/Base';

const cssToHideElement = css`
  position: absolute;
  clip-path: circle(0);
`;

export const VisuallyHiddenLabel = styled.span`
  ${cssToHideElement}
`;

export const VisuallyHiddenInput = styled.input`
  ${cssToHideElement}
`;

export const VisuallyHiddenLegend = styled.legend`
  ${cssToHideElement}
`;

export const VisuallyHiddenAnchor = styled.a`
  ${cssToHideElement}

  &:focus {
    border-radius: 3px;
    outline: #d17a23 auto 1px !important;
    -webkit-box-shadow: 0 0 5px #d17a23;
    box-shadow: 0 0 5px #d17a23;
    position: absolute !important;
    top: 1rem;
    left: 1rem;
    clip-path: none;
    z-index: ${ZIndex.SKIP_LINK};
    color: #007c89;
  }
`;
